import { request } from '@/lib/request'
import { RechargePresetsResponse } from '@/types/setting'

export async function getRechargePresets() {
  return request<RechargePresetsResponse>('/api/pay/recharge_presets', {
    method: 'GET',
  })
}

export interface PayChannelOption {
  pay_channel: number // 1: 微信支付, 2: 支付宝
  name: string
}

export async function getPayChannels() {
  return request<{ channels: PayChannelOption[] }>('/api/pay/channels', {
    method: 'GET',
  })
}
